import { gql } from '@apollo/client';

export const GET_LATEST_PICKUP_ROUTE_HISTORY = gql`
  query GetLatestPickupRouteHistory($warehouseId: Long!, $pickupDate: String!) {
    getLatestPickupRouteHistory(warehouseId: $warehouseId, pickupDate: $pickupDate) {
      warehouseId
      pickupDate
      routeId
      status
    }
  }
`;


 